module.exports = __webpack_public_path__ + "static/media/viirtue-logo.f7efab5c.png";